'use client';

import ErrorBoundary from '@noirproperties/react/error-boundary';
import { Button } from '@noirproperties/ui/components/ui/button';
import { QueryErrorResetBoundary } from '@tanstack/react-query';

type ErrorBoundaryWithResetProps = {
  children: React.ReactNode;
};

export function ErrorBoundaryWithReset({
  children,
}: ErrorBoundaryWithResetProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          // eslint-disable-next-line react/no-unstable-nested-components -- Required for error boundary
          fallbackRender={({ resetErrorBoundary }) => (
            <div className="prose mx-auto max-w-2xl">
              <p>There was an error!</p>

              <Button onClick={resetErrorBoundary}>Try again</Button>
            </div>
          )}
          onReset={reset}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
